import baseApi, {provideTag} from './baseApi'

const accountReportApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAccountReports: build.query({
            query: (query) => {
                const params = query ? `?${query}` : ''
                return {
                    url: `account_report${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Account_Report'),
        }),
        deleteAccountReport: build.mutation({
            query: (id) => {
                return {
                    url: `account_report/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Account_Report'],
        }),
        createAccountReport: build.mutation({
            query: (data) => {
                console.log('create account mutation req', {data})
                return {
                    url: `account_report`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Account_Report'],
        }),
    }),
    overrideExisting: false,
})

export default accountReportApi

export const {
    useGetAccountReportsQuery,
    useDeleteAccountReportMutation,
    useCreateAccountReportMutation,
} = accountReportApi
